import { Card, styled, cardContentClasses } from "@tm/components"
import { CardProps } from "@tm/controls"
import { offerItemClasses, offerItemName } from "@tm/themes"
import { classes } from "@tm/utils"
import { forwardRef } from "react"

const OfferItemCardComponent = forwardRef<HTMLDivElement, CardProps>((props, ref) => (
    <Card {...props} className={classes(offerItemClasses.root, props.className)} ref={ref} />
))
export const OfferItemCard = styled(OfferItemCardComponent, {
    name: offerItemName,
    slot: "root",
    overridesResolver: (_, styles) => styles.root,
})({
    width: 250,
    display: "flex",
    flexDirection: "column",
    [`.${cardContentClasses.root}`]: {
        padding: "8px 10px 0",
    },
})
